import { useCallback } from 'react';

import { requestNotificationPermission } from '../../notifications/systemNotifications';
import { useSystemNotificationsPermissionTrackingEvents } from './useSystemNotificationsPermissionTrackingEvents';

/**
 * Wraps {@link requestNotificationPermission} with tracking side effects: fires
 * the Allowed/Denied Segment events based on the user's decision. Returns the
 * same result as the util so callers can still branch on it (e.g. to show the
 * soft prompt when a user gesture is required).
 */
export function useRequestNotificationPermissionCallback() {
  const { trackPermissionAllowed, trackPermissionDenied } = useSystemNotificationsPermissionTrackingEvents();

  return useCallback(async () => {
    const result = await requestNotificationPermission();

    switch (result) {
      case 'granted':
        trackPermissionAllowed();
        break;
      case 'denied':
        trackPermissionDenied();
        break;
      default:
        break;
    }

    return result;
  }, [trackPermissionAllowed, trackPermissionDenied]);
}
